export const GTM_EVENT_NAMES = {
    MAIN_NAVIGATION: "main_navigation",
    PQP_INTERACTION: "pqp_interaction",
    PQP_IMPRESSION: "pqp_impression",
    HP_INTERACTION: "hp_interaction",
    ABOUT_INTERACTION: "about_interaction",
    TYP_INTERACTION: "typ_interaction",
    QUESTIONNAIRE_INTERACTION: "questionaire_interaction",
    PURCHASE: "purchase",
    PURCHASE_CTA_CLICK: "purchase_cta_click",
    PRODUCT_CLICK: "product_click",
    PERSONAL_INFO_SUBMITTED: "personal_info_submitted",
    CHECKOUT_STEP_CLICK: "checkout_step_click",
    ORDER_COUPON: "order_coupon",
    ORDER_SUMMARY: "order_summary",
    PURCHASE_ATTEMPT: "purchase_attempt",
    // Marketing spelling is intentional ("expresss_checkout", triple "s") to
    // match the existing analytics schema — do not "fix" it.
    EXPRESS_CHECKOUT: "expresss_checkout",
    LP_INTERACTION: "lp_interaction",
    PDP_INTERACTION: "pdp_interaction",
    SCIENCE_INTERACTION: "science_interaction",
    REVIEWS_INTERACTION: "reviews_interaction",
    VIDEO_SOUND: "video_sound",
    VIDEO_RESTART: "video_restart",
    VERIFY_ID_POPUP: "verify_id_pop_up",
    USER_INTERACTION: "user_interaction",
    MYAC_INTERACTION: "myac_interaction",
    SAVE_SHIPPING_INFO: "save_shipping_info",
} as const;

export type GTM_EVENTS = typeof GTM_EVENT_NAMES[keyof typeof GTM_EVENT_NAMES]
